/*
# Focus Out Event Handler for Multiple Containers

This JavaScript code snippet is designed to add a `focusout` event listener to multiple container elements. The purpose of this event listener is to detect when the focus leaves a specified container and then perform an action, such as clicking another element. This is particularly useful for implementing UI behaviors where an element should close or change state when the user interacts with other parts of the page.

## How It Works

1. **Data Attribute Selection**: The script selects all elements with the `data-close-on-focusout` attribute. This attribute should contain a comma-separated list of selectors. The first selector identifies the container that should close when focus is lost, and the second selector (optional) specifies an element to be clicked when the container loses focus.

2. **Event Listener Addition**: For each element with the `data-close-on-focusout` attribute, the script adds a `focusout` event listener to the container specified by the first selector in the attribute's value.

3. **Focus Out Detection**: When a `focusout` event occurs, the script checks if the new focus target is outside the container. If it is, the script assumes focus has left the container.

4. **Action Execution**: If focus has left the container, the script performs an action specified by the second selector in the `data-close-on-focusout` attribute's value, typically clicking an element.

Example:
<div class="typeahead__container" data-close-on-focusout=".typeahead__container,#full-bg">
    <!-- Container content -->
</div>
*/
if(window.innerWidth > 991){
    var elements = document.querySelectorAll('[data-close-on-focusout]');

    for (var i = 0; i < elements.length; i++) {
        (function(el) {
            var elementIds = el.attributes['data-close-on-focusout'].value;
            var elementIdArray = elementIds.split(',');

            // Select the container element
            var container = document.querySelector(elementIdArray[0]);

            // Add a focusout event listener to the container
            container.addEventListener('focusout', function(event) {
                // Check if the new focus target is outside the container
                if (!container.contains(event.relatedTarget)) {
                    console.log('Focus has left the container');
                    // Handle focus leaving the container
                    document.querySelector(elementIdArray[1]).click();
                }
            });
        })(elements[i]);
    }
}
